<div class="card p-5">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

  <div class="flex justify-content-between align-items-center mb-4">
    <div>
      <h2 class="m-0 font-bold text-xl text-900">Pagos web</h2>
      <p class="text-600 text-sm mt-1">Consulta el estado de pagos MercadoPago de pedidos web. Ya no se validan vouchers.</p>
    </div>
    <button pButton icon="pi pi-refresh" label="Actualizar" class="p-button-outlined p-button-secondary" (click)="loadOrders()"></button>
  </div>

  <p-table [value]="orders" [lazy]="true" (onLazyLoad)="loadOrders($event)"
           [first]="first" [rows]="rows" [totalRecords]="totalRecords" [paginator]="true"
           [rowsPerPageOptions]="[10, 25, 50]"
           [loading]="loading" responsiveLayout="scroll" [rowHover]="true">
    <ng-template pTemplate="header">
      <tr>
        <th>ID</th>
        <th>Fecha</th>
        <th>Cliente</th>
        <th>Canal</th>
        <th>Estado pago</th>
        <th>MP status</th>
        <th>Monto</th>
        <th>Refs MP</th>
        <th>Accion</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-order>
      <tr>
        <td class="font-bold">#{{order.id}}</td>
        <td class="text-sm">{{order.createdAt | peruDate:'dd/MM/yyyy, HH:mm'}}</td>
        <td>
          <div class="font-bold">{{order.clientName}}</div>
          <div class="text-xs text-500">{{order.clientPhone}}</div>
        </td>
        <td>
          <p-tag [value]="channelLabel(order)" [severity]="order.paymentChannel === 'MERCADOPAGO' ? 'info' : 'secondary'"></p-tag>
        </td>
        <td>
          <p-tag [value]="order.paymentStatus" [severity]="order.paymentStatus === 'PAGO_COMPLETO' ? 'success' : (order.paymentStatus === 'RECHAZADO' ? 'danger' : 'warn')"></p-tag>
        </td>
        <td class="text-sm">{{ order.mpStatus || '—' }}</td>
        <td class="font-bold text-green-600">
          {{order.totalAmount | currency:'PEN':'symbol'}}
        </td>
        <td class="text-xs">
          <div *ngIf="order.mpPaymentId"><strong>pay:</strong> {{order.mpPaymentId}}</div>
          <div *ngIf="order.mpPreferenceId" class="text-500" style="max-width:140px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;" [title]="order.mpPreferenceId">
            <strong>pref:</strong> {{order.mpPreferenceId}}
          </div>
          <span *ngIf="!order.mpPaymentId && !order.mpPreferenceId" class="text-500">—</span>
        </td>
        <td>
          <button pButton label="Detalle" icon="pi pi-eye" class="p-button-sm p-button-help" (click)="reviewOrder(order)"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="9" class="text-center p-5">
          <div class="flex flex-column align-items-center">
            <i class="pi pi-check-circle text-green-500 text-4xl mb-3"></i>
            <span class="font-bold text-lg text-700">Sin pagos web pendientes</span>
            <span class="text-600">Los pedidos MercadoPago pendientes o rechazados apareceran aqui.</span>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog [(visible)]="detailDialog" [style]="{width: '720px'}" header="Pedido web #{{selectedOrder?.id}}" [modal]="true" styleClass="p-fluid">
  <div *ngIf="selectedOrder" class="grid">
    <div class="col-12 md:col-6">
      <div class="p-3 border-1 border-gray-200 border-round bg-gray-50 h-full">
        <div class="mb-3 border-bottom-1 border-gray-200 pb-2">
          <span class="block text-600 text-sm mb-1 font-bold uppercase">Cliente</span>
          <span class="block font-bold text-xl">{{selectedOrder.clientName}}</span>
          <div class="text-sm mt-1">{{selectedOrder.clientPhone}}</div>
          <div class="text-sm text-600" *ngIf="selectedOrder.email">{{selectedOrder.email}}</div>
        </div>
        <div class="mb-3 border-bottom-1 border-gray-200 pb-2">
          <span class="block text-600 text-sm mb-1 font-bold uppercase">Entrega</span>
          <div class="font-bold text-800">{{selectedOrder.district}}</div>
          <div class="text-700 my-1">{{selectedOrder.deliveryAddress}}</div>
        </div>
        <div>
          <span class="block text-600 text-sm mb-1 font-bold uppercase">Total</span>
          <span class="font-bold text-xl text-green-600">{{selectedOrder.totalAmount | currency:'PEN':'symbol'}}</span>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-6">
      <div class="p-3 border-1 border-blue-100 border-round bg-blue-50 h-full">
        <span class="block text-600 text-sm mb-2 font-bold uppercase">MercadoPago</span>
        <div class="text-sm mb-2"><strong>Canal:</strong> {{ channelLabel(selectedOrder) }}</div>
        <div class="text-sm mb-2"><strong>Estado pedido:</strong> {{ selectedOrder.paymentStatus }}</div>
        <div class="text-sm mb-2"><strong>MP status:</strong> {{ selectedOrder.mpStatus || '—' }}</div>
        <div class="text-sm mb-2" style="word-break: break-all;"><strong>Preference:</strong> {{ selectedOrder.mpPreferenceId || '—' }}</div>
        <div class="text-sm mb-3" style="word-break: break-all;"><strong>Payment ID:</strong> {{ selectedOrder.mpPaymentId || '—' }}</div>
        <div class="mt-2" *ngIf="selectedOrder.paymentChannel === 'MERCADOPAGO'">
          <span class="block text-600 text-xs mb-1 font-bold uppercase">Historial de pago</span>
          <div class="text-xs text-700" *ngIf="selectedOrder.createdAt">Pedido creado: {{ selectedOrder.createdAt | peruDate:'dd/MM/yyyy h:mm a' }}</div>
          <div class="text-xs text-700" *ngIf="selectedOrder.mpPreferenceCreatedAt">Checkout MP generado: {{ selectedOrder.mpPreferenceCreatedAt | peruDate:'dd/MM/yyyy h:mm a' }}</div>
          <div class="text-xs text-700" *ngIf="selectedOrder.mpExpiresAt && !selectedOrder.paidAt">Expira: {{ selectedOrder.mpExpiresAt | peruDate:'dd/MM/yyyy h:mm a' }}</div>
          <div class="text-xs text-green-700" *ngIf="selectedOrder.mpApprovedAt">Pago aprobado: {{ selectedOrder.mpApprovedAt | peruDate:'dd/MM/yyyy h:mm a' }}</div>
          <div class="text-xs text-red-600" *ngIf="selectedOrder.mpRejectedAt">Pago rechazado: {{ selectedOrder.mpRejectedAt | peruDate:'dd/MM/yyyy h:mm a' }}</div>
          <div class="text-xs text-orange-600" *ngIf="selectedOrder.mpExpiredAt">Pago expirado: {{ selectedOrder.mpExpiredAt | peruDate:'dd/MM/yyyy h:mm a' }}</div>
        </div>

        <label class="font-bold text-sm mb-1 mt-3 block">Sincronizar por N° de pedido</label>
        <input pInputText [(ngModel)]="syncOrderId" placeholder="Ej: 125" class="w-full mb-2" />
        <button pButton label="Sincronizar pedido con MP"
                icon="pi pi-sync"
                class="p-button-info w-full mb-3"
                [loading]="isProcessing"
                (click)="syncMpOrder()">
        </button>

        <label class="font-bold text-sm mb-1 block">Sincronizar por Payment ID</label>
        <input pInputText [(ngModel)]="syncPaymentId" placeholder="Ej: 1234567890" class="w-full mb-2" />
        <button pButton label="Sincronizar con MP"
                icon="pi pi-sync"
                class="p-button-info w-full"
                [loading]="isProcessing"
                (click)="syncMpPayment()">
        </button>
        <p class="text-xs text-600 mt-2 m-0">La confirmacion automatica llega por webhook. Usa sync solo si el estado no se actualizo.</p>
      </div>
    </div>
  </div>
</p-dialog>